import PropTypes from 'prop-types';
import React from 'react';

import { Small, Medium, LargeUp } from 'components/MediaQuery';
import PageSectionTestimonialCarouselModel from 'models/PageSectionTestimonialCarousel';

import { TRACK_EVENT } from './constants';
import TestimonialCarouselDesktop from './TestimonialCarouselDesktop';
import TestimonialCarouselMobile from './TestimonialCarouselMobile';

class PageSectionTestimonialCarousel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeSlideIndex: 0,
    };
  }

  handleChange = index => {
    this.setState({ activeSlideIndex: index });
    this.props.trackEvent({
      eventCategory: TRACK_EVENT.CATEGORY,
      eventAction: TRACK_EVENT.ACTION,
      eventLabel: index,
    });
  };

  render() {
    const { data } = this.props;
    const { slides } = data;

    return (
      <div className="PageSectionTestimonialCarousel">
        <Small>
          <TestimonialCarouselMobile
            slides={slides}
            handleChange={this.handleChange}
            activeSlideIndex={this.state.activeSlideIndex}
          />
        </Small>
        <Medium>
          <TestimonialCarouselMobile
            slides={slides}
            handleChange={this.handleChange}
            activeSlideIndex={this.state.activeSlideIndex}
          />
        </Medium>
        <LargeUp>
          <TestimonialCarouselDesktop
            slides={slides}
            handleChange={this.handleChange}
            activeSlideIndex={this.state.activeSlideIndex}
          />
        </LargeUp>
      </div>
    );
  }
}

PageSectionTestimonialCarousel.propTypes = {
  data: PropTypes.instanceOf(PageSectionTestimonialCarouselModel).isRequired,
  trackEvent: PropTypes.func,
};

PageSectionTestimonialCarousel.defaultProps = {
  trackEvent: () => {},
};

export default PageSectionTestimonialCarousel;
